import { createActions, handleActions } from 'redux-actions';
import { Map } from 'immutable';

const initState = Map({});

export const { getPersonalConfig, updatePersonalConfig } = createActions({
  GET_PERSONAL_CONFIG: result => {
    return result;
  },
  UPDATE_PERSONAL_CONFIG: result => {
    return result;
  }
});

const personalConfig = handleActions(
  {
    [getPersonalConfig]: (state, action) => {
      return Map(action.payload.data);
    },
    [updatePersonalConfig]: (state, action) => {
      const { data, type } = action.payload;
      return state.updateIn([type], () => data);
    }
  },
  initState
);

export default personalConfig;
